import { css } from 'styled-components';

export const StyledSvgIcon = css`
  .icon-bg {
    transition: all 0.3s ease;
    fill: ${(props) => (props.$isSelected ? '#105CF2' : 'transparent')};
    transform-origin: center;
    transform: scale(${(props) => (props.$isSelected ? 1 : 0.95)});
  }

  .icon-path {
    transition: all 0.3s ease;
    transform-origin: center;
    fill: ${(props) => (props.$isSelected ? 'white' : '#4C4D56')};
  }

  &:hover {
    .icon-bg {
      transform: scale(1);
    }

    .icon-path {
      transform: scale(1.14);
    }
  }
`;

export const StyledDrawingIcon = css`
  .icon-path {
    stroke: ${(props) => (props.$isSelected ? '#2563EB' : '#686B71')};
    transition: stroke 0.2s ease;
  }

  .icon-fill {
    fill: ${(props) => (props.$isSelected ? '#2563EB' : '#686B71')};
    transition: fill 0.2s ease;
  }

  &:hover {
    .icon-path {
      stroke: #fff;
    }

    .icon-fill {
      fill: #fff;
    }
  }
`;

export const themeOptions = {
  token: {
    fontSize: 16,
    colorText: '#000000',
    colorPrimary: '#0E5AF1',
    colorInfo: '#0E5AF1',
    borderRadius: 6,
    colorTextPlaceholder: '#9C9C9B',
    fontWeight: 400,
    colorTextDisabled: '#353535',
    colorBgContainerDisabled: '#F8F8F8',
    sizeStep: 0,
    sizeUnit: 0,
    boxShadow:
      '\n      0 0px 3px 0 rgba(0, 0, 0, 0.08),\n      0 0px 3px 0 rgba(0, 0, 0, 0.08),\n      0 0px 3px 0 rgba(0, 0, 0, 0.08)\n    '
  },
  components: {
    Button: {
      contentFontSize: 14,
      contentFontSizeLG: 17,
      contentLineHeight: 1.2,
      contentLineHeightLG: 1,
      contentLineHeightSM: 1.1,
      onlyIconSize: 24,
      onlyIconSizeLG: 24,
      onlyIconSizeSM: 24,
      paddingBlockLG: 14,
      controlHeightSM: 32,
      controlHeight: 40,
      controlHeightLG: 48,
      paddingBlock: 11.5,
      paddingBlockSM: 7.5,
      paddingInlineSM: 10,
      paddingInlineLG: 16,
      paddingInline: 16,
      defaultBorderColor: 'rgb(234, 234, 234)',
      defaultColor: 'rgb(100, 100, 100)',
      defaultHoverBg: 'rgb(217, 217, 217)',
      defaultHoverBorderColor: 'rgb(217, 217, 217)',
      defaultHoverColor: 'rgb(100, 100, 100)',
      defaultShadow: '0',
      dangerShadow: '0',
      fontWeight: 600,
      primaryShadow: '0',
      defaultActiveColor: 'rgb(100, 100, 100)',
      defaultActiveBorderColor: 'rgb(217, 217, 217)',
      defaultActiveBg: 'rgb(217, 217, 217)',
      fontSize: 14,
      borderRadiusLG: 6,
      borderRadiusSM: 6,
      defaultBg: 'rgb(234, 234, 234)',
      colorBgContainerDisabled: 'rgb(234, 234, 234)',
      defaultGhostColor: 'rgb(0, 0, 0)',
      colorPrimary: '#0E5AF1',
      colorPrimaryActive: '#0E5AF1',
      colorPrimaryBorder: '#0E5AF1',
      colorPrimaryHover: '#0E5AF1',
      colorTextDisabled: 'rgb(178, 178, 178)',
      colorText: 'rgb(100, 100, 100)',
      borderColorDisabled: 'rgb(234, 234, 234)',
      groupBorderColor: 'rgb(235, 73, 69)',
      opacityLoading: 1
    },
    Modal: {
      titleFontSize: 20,
      fontSize: 16,
      colorIcon: 'rgb(255, 255, 255)',
      colorIconHover: 'rgb(255, 255, 255)',
      colorPrimaryBorder: '#0E5AF1',
      colorText: '#0E5AF1',
      boxShadow: '      0px 0px 3px 0px #0000004D    ',
      fontWeightStrong: 500,
      borderRadiusSM: 8,
      controlHeight: 64
    }
  },
  palette: {
    mainColor: '#105CF2',
    primary: {
      lightBlueGrey: '#C1C4CE',
      lightGrey: '#A9A9A9',
      grey: '#4C4D56',
      dark: '#0E48BA',
      main: '#105CF2'
    },
    grey: {
      900: '#353535'
    },
    black: '#000000',
    white: '#FFFFFF',
    shadow: '0px 0px 3px 0px #0000004D'
  }
};
